import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Box, Card, Chip } from '@material-ui/core'

import { DataProcessStatusChip } from 'views/DataProcesses/components/index'
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from 'components/Table'

import usePermission from 'hooks/usePermissions'

import { routes } from 'Routes'
import constants from 'constants/index'
import helpers from 'helpers'
import useStyles from './styles'

const DataProcessRow = ({ dataProcess }) => {
  const history = useHistory()
  const { some } = usePermission()
  const classes = useStyles()

  const permitRedirectToShow = () => {
    return some([
      constants.permissions.DATA_PROCESSES.LIST,
      constants.permissions.DATA_PROCESSES.CREATE,
    ])
  }

  const handleGoView = (dataProcessId) => {
    if (permitRedirectToShow)
      history.push(
        reverse(routes.dataProcess.view, { dataProcessId: dataProcessId }),
      )
  }

  return (
    <TableRow
      onClick={() => handleGoView(dataProcess.id)}
      pointer="true"
      key={dataProcess.id}
    >
      <TableCell>{dataProcess.id}</TableCell>
      <TableCell>
        <Box display="flex">
          <Box
            mr={1}
            className={clsx({ [classes.blueDot]: dataProcess.inAudit })}
          />
          <Box>{dataProcess.name}</Box>
        </Box>
      </TableCell>
      <TableCell>{dataProcess.company.name}</TableCell>
      <TableCell>{dataProcess.department.name}</TableCell>
      <TableCell disableTooltip>
        <Chip
          label={dataProcess?.dataProcessRisk?.label}
          style={{
            backgroundColor: dataProcess?.dataProcessRisk?.color || '#000',
            color: dataProcess?.dataProcessRisk?.colorSecondary || '#fff',
          }}
        />
      </TableCell>
      <TableCell>{`${helpers.formatters.date(
        dataProcess.updatedAt,
      )} - ${helpers.formatters.hours(dataProcess.updatedAt)}`}</TableCell>
      <TableCell disableTooltip>
        <DataProcessStatusChip
          title={helpers.dataProcesses.status(dataProcess.statusId)}
          statusId={dataProcess.statusId}
        />
      </TableCell>
    </TableRow>
  )
}

DataProcessRow.propTypes = {
  dataProcess: PropTypes.object.isRequired,
}

const DataProcessTable = ({ dataProcesses, isLoading }) => {
  const classes = useStyles()

  return (
    <Box className={classes.root} width="100%">
      <Card>
        <PerfectScrollbar
          options={{ wheelPropagation: false, useBothWheelAxes: true }}
        >
          <Table
            emptyMessage="Nenhum processamento de dados encontrada"
            isLoading={isLoading}
            noWrap
          >
            <TableHead>
              <TableRow>
                <TableCell width="10%">Identificador</TableCell>
                <TableCell width="20%">Nome</TableCell>
                <TableCell width="20%">Empresa</TableCell>
                <TableCell width="20%">Departamento</TableCell>
                <TableCell width="10%">Risco</TableCell>
                <TableCell width="10%">Ultima atualização</TableCell>
                <TableCell width="10%">Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {dataProcesses?.map((dataProcess) => (
                <DataProcessRow
                  dataProcess={dataProcess}
                  key={dataProcess.id}
                />
              ))}
            </TableBody>
          </Table>
        </PerfectScrollbar>
      </Card>
    </Box>
  )
}

DataProcessTable.propTypes = {
  dataProcesses: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default DataProcessTable
